<div class="panel-heading">
    <p class="panel-title"><b>Categorization Section
        </b></p>
</div>
<div class="panel-body nopadding">
    <div class="col-md-12 text-left p-l-6">
        <strong [ngClass]="{'smallFont': !displayDivider}">Order Categorization:</strong>
    </div>

    <div class="ui-fluid">
        <p-scrollPanel styleClass="customScroll">
            <div class="ui-g">
                @for(item of orderCategoryItems; track item + '-'+ $index) {
                <div class="customBox text-center">
                    <div [ngClass]="displayDivider ? 'greenBoxSmall' : item.boxClass">
                        <a class="disabled-link" (click)="openTransactionScreen('Orders', item.screenKey)">
                            <ul class="greenBoxList">
                                <li class="smallFont"><span>{{ item.label }}</span></li>
                                <li class="smallFont">
                                    <span>
                                        {{ item.count }}
                                        @if(item.showPercentage){
                                        <ng-container>
                                            ({{ getPercentage(item.count, orderCategary?.reportableOrders) }}%)
                                        </ng-container>
                                        }
                                    </span>
                                </li>
                                <li class="smallFont"><span>{{ item.shares | number }}</span></li>
                            </ul>
                        </a>
                    </div>
                </div>
                }
            </div>
        </p-scrollPanel>
    </div>
</div>
<div class="panel-body nopadding">
    <div class="col-md-12 text-left p-l-6">
        <strong [ngClass]="{'smallFont': !displayDivider}">Route Categorization:</strong>
    </div>

    <div class="ui-fluid">
        <p-scrollPanel styleClass="customScroll">
            <div class="ui-g">
                @for(item of routeCategoryItems; track item + '-'+ $index) {
                <div class="customBox text-center">
                    <div [ngClass]="displayDivider ? 'greenBoxSmall' : item.boxClass">
                        <a class="disabled-link" (click)="openTransactionScreen('Routes', item.screenKey)">
                            <ul class="greenBoxList">
                                <li class="smallFont"><span>{{ item.label }}</span></li>
                                <li class="smallFont">
                                    <span>
                                        {{ item.count }}
                                        @if(item.percentageBasis){
                                        <ng-container>
                                            ({{ getPercentage(item.count, item.percentageBasis) }}%)
                                        </ng-container>
                                        }
                                    </span>
                                </li>
                            </ul>
                        </a>
                    </div>
                </div>
                }
            </div>
        </p-scrollPanel>
    </div>
</div>

<div class="panel-body nopadding">
    <div class="ui-fluid">
        <p-scrollPanel styleClass="customScroll">
            <div class="ui-g">
                <div class="routeContainer">
                    @for(section of subRouteSections; track section + '-'+ $index) {
                    <div class="routeSection">
                        <div class="categaoryBlock">
                            <div class="categaoryTitle">
                                <a class="disabled-link" (click)="openTransactionScreen('Routes', section.screenKey)">
                                    <li class="smallFont">
                                        <span>
                                            {{ section.title }} {{ section.count }}
                                            ({{ getPercentage(section.count, section.percentageBasis) }}%)
                                        </span>
                                    </li>
                                </a>
                            </div>
                        </div>

                        <div class="ui-g">
                            @for(item of section.items; track item + '-'+ $index) {
                            <div class="customBox text-center">
                                <div [ngClass]="displayDivider ? 'greenBoxSmall' : 'blueBox'">
                                    <a class="disabled-link" (click)="openTransactionScreen('Routes', item.screenKey)">
                                        <ul class="greenBoxList">
                                            <li class="smallFont"><span>{{ item.label }}</span></li>
                                            <li class="smallFont">
                                                <span>
                                                    {{ item.count }}
                                                    ({{ getPercentage(item.count, item.percentageBasis) }}%)
                                                </span>
                                        </ul>
                                    </a>
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                    }
                </div>
            </div>
        </p-scrollPanel>
    </div>
</div>